import React from "react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <div>
      <nav>
        <Link className="title" to="/">
          Teresa DeAnn Langley, LPC
        </Link>
        <div className="menu">
          {menuOpen ? (
            <FaTimes className="bars" onClick={toggleMenu} />
          ) : (
            <FaBars className="bars" onClick={toggleMenu} />
          )}
        </div>
        <ul className={menuOpen ? "open" : ""}>
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          {/* <li>
            <NavLink to="/about">About</NavLink>
          </li> */}
          <li>
            <NavLink to="/nsa">No Surprise Act / Good Faith Estimate</NavLink>
          </li>
          <li>
            <NavLink to="/contact">Contact Us</NavLink>
          </li>
          <li>
            <NavLink to="location">Location</NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
